import React from 'react';
import './withLoadingOverlay.css';
import Spinner from '../../Spinner/Spinner';
import { getAdditionalProps } from '../utils';
var getLoadingTbodyProps = getAdditionalProps('dm-table__body dm-table__loading-overlay');
var LoadingComponent = function LoadingComponent(props) {
  return true || props.loading ? /*#__PURE__*/React.createElement("div", {
    className: "dm-table__loading-spinner"
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: 32
  })) : null;
};
export default function withLoadingOverlay() {
  return function (TableComponent) {
    return function (props) {
      var loadingProps = {};
      if (props.loading) {
        loadingProps = {
          LoadingComponent: LoadingComponent,
          getTbodyProps: getLoadingTbodyProps
        };
      }
      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(TableComponent, Object.assign({}, props, loadingProps)));
    };
  };
}